/* eslint-disable no-param-reassign */
import { SURVEYS_SELECT_SURVEY_VERSION } from 'state/actionCreators/surveys';

export const selectSurveyVersion = (surveyVersionId) => (dispatch) =>
  dispatch(SURVEYS_SELECT_SURVEY_VERSION({ version: surveyVersionId }));
